<template>
<draggable v-model="products.data" group="products" draggable=".product" @start="drag=true" @end="drag=false"
class="layout row wrap justify-center px-3 sp-product-list" @change="onChange">
    <template v-if="!typeSelected || !typeSelected.highlight">
        <v-flex xl2 md4 sm6 xs10 class="full-height" slot="header" v-if="!$vuetify.breakpoint.xsOnly">
            <v-card hover height="180" class="flexcard" @click="showForm()">
                <v-layout class="grow" align-center>
                    <v-flex>
                        <v-card-text class="text-xs-center">
                            <v-icon x-large>add</v-icon>
                        </v-card-text>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </template>
    <v-flex xl2 lg4 md4 sm6 xs10 v-for="product in products.data" 
        :key="product.code" class="full-height"
        draggable="false" style="transform:translateZ(0px);"
    >
        <sp-product-mobile :product="product"></sp-product-mobile>
    </v-flex>
    <v-flex xs12 v-if="products.data.length < products.totalRecords" slot="footer" class="text-xs-center">
        <v-btn color="secondary" @click="showMore()">Carregar Mais</v-btn>
    </v-flex>
</draggable>
</template>

<script>
import {mapGetters} from 'vuex'
import SpProductMobile from '../components/SpProductMobile'
import draggable from 'vuedraggable'

export default {
    components:{
        SpProductMobile,
        draggable
    },
    data(){
        return {
            sheet: false,
            radios:''
        }
    },
    async created () {
        window.addEventListener('scroll', this.onScroll);
        this.$store.commit('SET_PAGINATION',{limit:30,page:1,order_column:'',order_dir:''})
        this.$store.state.loading = true
        await this.$store.dispatch('fetchProducts')
        this.$store.state.loading = false
    },
    destroyed () {
        window.removeEventListener('scroll', this.onScroll);
    },
    computed:{
        ...mapGetters([
            'products',
            'typeSelected'
        ])
    },
    methods:{
        async showMore(){
            let length = this.products.data.length
            if(length >= this.products.limit && length < this.products.recordsTotal){
                this.$store.commit('SET_PAGINATION',{limit:length+this.products.limit})
                await this.$store.dispatch('fetchProducts')
            }
        },
        onScroll (e) {
            if((window.innerHeight + window.scrollY) >= document.body.offsetHeight){
                this.showMore()
            }
        },
        onChange(evt){
            if(evt.moved){
                const data = {
                    product_id:evt.moved.element._id,
                    order:evt.moved.newIndex
                }
                this.$store.dispatch('updateProduct',data)
            }
        },
        showForm(product=null){
            this.$store.commit('FETCH_PRODUCT',product)
            this.$store.commit('TOGGLE_PRODUCT_DIALOG')
        },
    }
}
</script>

<style lang="scss" scoped>
    .sp-product-list{
        overflow-y: auto;
        overflow-x: hidden;
    }
    .full-height .flex{
        display: flex;
    }
    .full-height > .card{
        flex: 1 1 auto
    }
    .flexcard {
        display: flex;
        flex-direction: column;
    }
</style>